module.exports = __webpack_public_path__ + "img/logo.bd9d96c2.png";